<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3aTvsp/tc-custom/9781782111962.jpg?1700280082274" alt="This image is the cover for the book Weekend"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Weekend
      </h1>
      <p class="bookDescription body article font2">
        <b>An “illuminating and thought-provoking” novel revolving around an academic gathering at a hotel on a Scottish island (Irvine Welsh, <i>The Guardian</i>).</b><br/>  <br/> At Willowdale, a Victorian mansion hotel on a Scottish island, a group of English Literature lecturers and students have arrived from Glasgow. They are preparing for a weekend of lectures and intellectual discussions, though some look forward to less studious interactions as well. But as they gather, they don’t yet know that this brief weekend will mark a major turning point in the emotional lives of several people, in ways that they never expected, in a novel from a Whitbread Award author that is filled with “deft one-liners [and an] undertow of sadness” (<i>Times Literary Supplement</i>).<br/>  <br/> “Wonderfully witty and wistful.” —<i>The Daily Mail</i><br/>  <br/> “The great McIlvanney themes—class, guilt, the power of the book, the difficulty of goodness—are all there, seething under the surface.” —<i>The Daily Telegraph</i>)
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William McIlvanney
      </h2>
      
      <p class="authorDescription body article">William McIlvanney's first novel, Remedy is None, won the Geoffrey Faber Memorial Prize and with Docherty he won the Whitbread Award for Fiction. Laidlaw and The Papers of Tony Veitch both gained Silver Daggers from the Crime Writers' Association. Strange Loyalties, the third in the Detective Laidlaw trilogy, won the Glasgow Herald's People's Prize. He died in December 2015.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canongate Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a800ed6